import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../authentication/auth.service';
import { Utilisateur } from './utilisateur';
import { map } from 'rxjs/operators';


@Injectable()
export class UtilisateurService {

    constructor(private http: HttpClient, private authService: AuthService) { }

    getUtilisateur(): Observable<Utilisateur> {
        let cleSession = this.authService.getCleSession();
        let cle = this.authService.getCleUser();
        return this.http.get<any>('/api/signaletique/'+cleSession+'/'+cle).pipe(map(
            utilisateur => {
                return utilisateur;
            }));
    }
}
